export default class Config {
}
Config.appName = 'Elecfes - Inventario';
Config.user_cookie = 'user_elecfes_inventario';
